import React, {useEffect, useState} from 'react'
import Select from 'react-select'
import {
  ChargeTypesClient,
  ChargeTypesQueryParams,
} from '../../../infrastracture/api/ChargeTypesClient'
import customStyles from './customStyles'

interface Props {
  name?: string
  defaultValue?: any
  placeholder?: string
  disabled?: boolean
  onChange?: (name: any, value: any, label?: any, fee?: any, costRate?: any, sellRate?: any, rateType?: any, type?: any) => void
  feesOnly?: boolean
  nonFeesOnly?: boolean
  excludeSettingFromClientId?: string
  category?: string
  enableQuoteSummary?: boolean
}

const ChargeTypeSelector: React.FC<Props> = (props: any) => {
  const {
    defaultValue,
    placeholder,
    disabled,
    name,
    onChange,
    feesOnly,
    nonFeesOnly,
    excludeSettingFromClientId,
    category,
    enableQuoteSummary = false,
  } = props

  const [options, setOptions] = useState<any>([])
  const [value, setValue] = useState<any>({})

  const defaultId = 'chargeTypeId'

  const populateData = React.useCallback(async () => {
    var query = new ChargeTypesQueryParams()

    if (excludeSettingFromClientId) query.WithExcludeSettingFromClientId(excludeSettingFromClientId)

    if (feesOnly) {
      query.WithFeesOnly(true)
    } else if (nonFeesOnly) {
      query.WithNonFeesOnly(true)
    }

    if (category) {
      query.WithCategory(category)
    }

    query.WithContext(enableQuoteSummary ? 'quoteSummary' : 'legacy')

    //TODO: SUPPORT SEARCH FOR PERFORMANCE AGAINST LARGE COLLECTIONS
    var data = (
      await ChargeTypesClient.List(query.Paginate(0, 10000).Sort('name', 'asc').WithActive(true))
    ).data

    if (data) {
      setOptions(
        data.data
          .map((item: any) => {
            return {
              value: item.id,
              label: item.name,
              fee: item.fee,
              costRate: item.costRate,
              sellRate: item.sellRate,
              rateType: item.rateType,
              type: item.type,
            }
          })
      )
    }
  }, [excludeSettingFromClientId, feesOnly, nonFeesOnly, category, enableQuoteSummary])

  useEffect(() => {
    populateData()
  }, [excludeSettingFromClientId, populateData, category])

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const handleChange = (values: any) => {
    const {value, label, fee, costRate, sellRate, rateType, type} = values
    setValue(values)
    onChange(defaultId, value, label, fee, costRate, sellRate, rateType, type)
  }

  return (
    <Select
      onChange={handleChange}
      value={value}
      options={options}
      placeholder={placeholder}
      isDisabled={disabled}
      id={name ? name : defaultId}
      name={name ? name : defaultId}
      styles={customStyles}
      menuPortalTarget={document.body}
    />
  )
}

export default ChargeTypeSelector
